import { isWelcomeEnabledForClient } from '../../lib/ab-tests/welcomeSplash';
import { WelcomeSplashVariant } from '../../interfaces/WelcomeSplashVariant';
import { Base } from './base';

function welcomeSplashDecided(
  this: Base,
  welcomeSplashVariant: WelcomeSplashVariant
) {
  if (!isWelcomeEnabledForClient()) return;

  this.instance?.track('[myAccount]welcomeSplash_decided', {
    ...this.default_properties,
    welcomeSplashVariant
  });
}

export default {
  welcomeSplashDecided
};
